export default ['Variable', 'ComponentMoleFlow', 'ComponentMassFlow', 'ComponentMassFrac', 'SpreadSheet', 'Dollar', 'Energy'];
